import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="-1 -1 20 20">
    <path
      fill="#3C80CF"
      d="M9 1.5C4.9 1.5 1.5 4.9 1.5 9s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5S13.1 1.5 9 1.5zm.8 11.3H8.2V8.2h1.5v4.6zm0-6H8.2V5.2h1.5v1.6z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/note-info.es6.js